import {User, UserObject} from '../../user/User';

 export class Member extends User {
    private _role: string;
    constructor(userObject: UserObject){
        super(userObject);
        this.roleOf = userObject.role ?? "learner";
    }
    get roleOf(){
        return this._role;
    }
    set roleOf(role : string) {
        if(role==undefined)
            this._role = "learner";
        else    
            this._role = role;
    }
}